export const ADMIN = "ADMINISTRATOR";
export const USER = "USER";
export const VERTIS = "VERTIS";
export const TADIG = "TADIG";
